/*global
  google
*/

import Glide from "@glidejs/glide";
import { Loader } from "@googlemaps/js-api-loader";

// maps API
const loader = new Loader({
  apiKey: "AIzaSyAiefms-Al1hZz3rYjXS8igeJnLyvdDZY0",
  version: "weekly",
  libraries: ["places"],
});
const stylesArray = [
  {
    featureType: "landscape",
    stylers: [{ saturation: -100 }, { lightness: 65 }, { visibility: "on" }],
  },
  {
    featureType: "poi",
    stylers: [
      { saturation: -100 },
      { lightness: 51 },
      { visibility: "simplified" },
    ],
  },
  {
    featureType: "road.highway",
    stylers: [{ saturation: -100 }, { visibility: "simplified" }],
  },
  {
    featureType: "road.arterial",
    stylers: [{ saturation: -100 }, { lightness: 30 }, { visibility: "on" }],
  },
  {
    featureType: "road.local",
    stylers: [{ saturation: -100 }, { lightness: 40 }, { visibility: "on" }],
  },
  {
    featureType: "transit",
    stylers: [{ saturation: -100 }, { visibility: "simplified" }],
  },
  { featureType: "administrative.province", stylers: [{ visibility: "off" }] },
  {
    featureType: "water",
    elementType: "labels",
    stylers: [{ visibility: "on" }, { lightness: -25 }, { saturation: -100 }],
  },
  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ hue: "#ffff00" }, { lightness: -25 }, { saturation: -97 }],
  },
];

const distanceTwoPoints = (lat1, lon1, lat2, lon2) => {
  const R = 6371e3; // meters
  const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
  const φ2 = (lat2 * Math.PI) / 180;
  const Δφ = ((lat2 - lat1) * Math.PI) / 180;
  const Δλ = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c; // in meters
  return Math.floor(d / 1000); // in kms
};

export default class Locator {
  constructor(data, root) {
    this.data = data;
    this.root = root;
    this.markers = [];
    // Markers
    this.settings = {
      glide: {
        type: "slider",
        startAt: 0,
        bound: true,
        rewind: false,
        perView: 3.2,
        breakpoints: {
          1199: {
            perView: 2.2,
          },
          991: {
            perView: 2.8,
          },
          767: {
            perView: 2.2,
          },
          575: {
            perView: 1.8,
          },
          460: {
            perView: 1.4,
          },
        },
      },
      defaultColour: "#333333",
      premiumColour: "#00205B",
      traditiColour: "#DB3000",
      markerPath:
        "M15.185,39.436h0L4.251,28.5c-.049-.051-.1-.1-.149-.15l-.061-.06A15.278,15.278,0,0,1-.406,16.98,16.9,16.9,0,0,1,4.616,5.43a17.183,17.183,0,0,1,5.632-3.767A16.547,16.547,0,0,1,16.576.4,15.212,15.212,0,0,1,31.927,16.167,16.9,16.9,0,0,1,26.9,27.717c-.074.074-.148.147-.223.22l-11.495,11.5ZM16,9.716a7.6,7.6,0,0,0-7.541,7.415A6.989,6.989,0,0,0,15.5,24.294a7.6,7.6,0,0,0,7.541-7.415A6.989,6.989,0,0,0,16,9.716Z",
      premiuPath:
        "M15.185,39.436h0L4.251,28.5c-.049-.051-.1-.1-.149-.15l-.061-.06A15.278,15.278,0,0,1-.406,16.98,16.9,16.9,0,0,1,4.616,5.43a17.183,17.183,0,0,1,5.632-3.767A16.547,16.547,0,0,1,16.576.4,15.212,15.212,0,0,1,31.927,16.167,16.9,16.9,0,0,1,26.9,27.717c-.074.074-.148.147-.223.22l-11.495,11.5ZM16,9.716a7.6,7.6,0,0,0-7.541,7.415A6.989,6.989,0,0,0,15.5,24.294a7.6,7.6,0,0,0,7.541-7.415A6.989,6.989,0,0,0,16,9.716Z",
      // "premiuPath": "M15.185,39.436h0L4.251,28.5c-.049-.051-.1-.1-.149-.15l-.061-.06A15.278,15.278,0,0,1-.406,16.98,16.9,16.9,0,0,1,4.616,5.43a17.183,17.183,0,0,1,5.632-3.767A16.547,16.547,0,0,1,16.576.4,15.212,15.212,0,0,1,31.927,16.167,16.9,16.9,0,0,1,26.9,27.717c-.074.074-.148.147-.223.22l-11.495,11.5Zm.872-32.344A9.642,9.642,0,0,0,6.6,16.886a9.642,9.642,0,0,0,9.46,9.794,9.642,9.642,0,0,0,9.46-9.794A9.642,9.642,0,0,0,16.057,7.092Zm-4.142,15.26v0l.743-4.838L9.093,14.154l4.833-.788,2.091-4.429L18.26,13.29l4.857.619-3.446,3.479.912,4.811L16.21,20l-4.293,2.353Z",
      svgMarker: {
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
      },
    };
    this.init();
  }

  init() {
    const self = this;
    // filters
    // Create an array going through all the filters present in the DOM, no duplicates
    this.filters = this.data
      .reduce(
        (acc, loc) =>
          Array.from(
            new Set([...loc.filters.map((filter) => filter.join(",,")), ...acc])
          ),
        []
      )
      .map((filter) => filter.split(",,"));
    const filtersEl = this.root.querySelector(".locator_filters");
    const filtersBtn = this.root.querySelector(".locator_filters button");
    const filtersLst = this.root.querySelector(".locator_filters .list");
    const filtersSbt = this.root.querySelector(
      ".locator_filters .locator_filters_cta"
    );
    if (filtersEl && filtersBtn && filtersLst && filtersSbt) {
      filtersBtn.addEventListener("click", () => {
        const filtersList = filtersBtn.nextElementSibling;
        if (!filtersList) return;
        filtersEl.classList.toggle("shown");
      });
      this.filters.forEach((filter) => {
        const checkBoxEl = document.createElement("DIV");
        checkBoxEl.className = "form-check";
        checkBoxEl.innerHTML = `
                                <input class="form-check-input" type="checkbox" value="${filter[0]}" id="${filter[0]}">
                                <label class="form-check-label" for="${filter[0]}">${filter[1]}</label>`;
        filtersLst.appendChild(checkBoxEl);
      });
      filtersSbt.addEventListener("click", (e) => {
        e.preventDefault();
        const tickedFilters = Array.from(
          filtersLst.querySelectorAll("input:checked")
        ).map((el) => el.id);
        filtersEl.classList.remove("shown");
        // clear search field
        if (searchInp) searchInp.value = "";
        this.root.classList.remove("searched");
        //
        this.root.classList.add("filtered");
        this.updateDOM(
          self.data.filter((loc) => {
            return tickedFilters.every((tag) =>
              loc.filters.some((filter) => filter[0] === tag)
            );
          })
        );
      });
    }

    // search
    const searchRadius = 20; // in km distanceTwoPoints
    const searchEl = this.root.querySelector(".locator_search");
    const searchInp = this.root.querySelector(".locator_search input");
    const placeHandler = () => {
      const place = this.autocomplete.getPlace();
      if (!place.geometry) {
        searchInp.placeholder = "Enter a place";
      } else {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        // center on the location
        self.map.panTo({ lat, lng });
        // geo search
        const data = self.data.map(function (loc) {
          const distance = distanceTwoPoints(loc.lat, loc.lng, lat, lng);
          const newLoc = Object.assign({}, loc);
          newLoc.distance = distance;
          return newLoc;
        });
        this.updateDOM(
          data
            .filter((loc) => {
              return loc.distance < searchRadius;
            })
            .sort((a, b) => {
              return a.distance - b.distance;
            })
        );
        this.root.classList.add("searched");
      }
    };
    if (searchEl && searchInp) {
      searchEl.addEventListener("submit", (e) => {
        e.preventDefault();
      });
    }

    // reset
    const resetEl = this.root.querySelector(".locator_reset");
    if (resetEl) {
      resetEl.addEventListener("click", () => {
        // clear search field
        if (searchInp) searchInp.value = "";
        this.root.classList.remove("searched");
        // reset checkboxes
        if (filtersLst)
          Array.from(filtersLst.querySelectorAll("input")).forEach(
            (input) => (input.checked = false)
          );
        this.root.classList.remove("filtered");
        //
        this.updateDOM(self.data);
      });
    }

    // carousel
    const carousel = this.root.querySelector(".glide");
    if (!carousel) return;
    this.glide = new Glide(carousel, this.settings.glide);
    // Make sure blocks are equal height
    this.glide.on(["mount.after"], this.equalHeight.bind(this));

    // map
    loader.load().then(() => {
      self.map = new google.maps.Map(self.root.querySelector(".locator-map"), {
        center: { lat: -37.81626642355492, lng: 144.9640545848708 },
        zoom: 11,
        styles: stylesArray,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      });
      this.autocomplete = new google.maps.places.Autocomplete(searchInp, {
        types: ["(regions)"],
        componentRestrictions: { country: ["AU"] },
        fields: ["geometry"],
      });
      this.autocomplete.addListener("place_changed", placeHandler);
      this.reset(self.data);
    });
  }

  equalHeight() {
    const lis = Array.from(
      this.root.querySelectorAll(".card .card-image + .card-body")
    );
    const maxHeight = lis.reduce(
      (total, current) => Math.max(total, current.scrollHeight),
      0
    );
    lis.forEach((el) => {
      el.style.minHeight = maxHeight + "px";
    });
  }

  updateDOM(data) {
    // Reset the carousel
    this.glide.destroy();
    const adsList = this.root.querySelector(".glide__slides");
    if (!adsList) return;
    adsList.innerHTML = "";
    data.forEach((loc) => {
      const newAd = document.createElement("LI");
      newAd.className = "glide__slide";
      newAd.innerHTML = loc.html;
      adsList.appendChild(newAd);
    });
    //this.glide = new Glide('.glide', this.settings.glide);
    // Hot fix for displaying carousel after filter
    const carousel = this.root.querySelector(".glide");
    this.glide = new Glide(carousel, this.settings.glide);
    this.glide.on(["mount.after"], this.equalHeight.bind(this));
    // Reset the map
    this.markers.forEach((marker) => {
      marker[0].setMap(null);
    });
    this.markers = [];
    this.reset(data);
  }

  reset(data) {
    const self = this;
    this.glide.mount();
    // Instantiate markers
    data.forEach((location, index) => {
      const markerSettings = Object.assign({}, self.settings.svgMarker, {
        anchor: new google.maps.Point(15, 30),
      });
      const icon = location.premium
        ? Object.assign({}, markerSettings, { path: self.settings.premiuPath })
        : Object.assign({}, markerSettings, { path: self.settings.markerPath });
      const dftMarker = Object.assign({}, icon, {
        fillColor: self.settings.defaultColour,
      });
      const hltMarker = Object.assign({}, icon, {
        fillColor: location.premium
          ? self.settings.premiumColour
          : self.settings.traditiColour,
      });
      const position = {
        lat: location.lat,
        lng: location.lng,
      };
      const marker = new google.maps.Marker({
        position,
        icon: dftMarker,
        map: self.map,
      });
      self.markers.push([marker, location.premium]);
      marker.addListener("click", () => {
        self.removeFocus();
        self.activeSlide = index;
        self.map.panTo(position);
        marker.setIcon(hltMarker);
      });
    });
    // event listener
    self.glide &&
      self.glide._c.Clones.items.reverse().forEach((slide, index) => {
        slide.addEventListener("click", () => {
          self.focus(index);
        });
        const link = slide.querySelector("a.card-cta");
        link.addEventListener("focus", () => {
          self.focus(index);
        });
      });
    self.glide &&
      self.glide._c.Html.slides.forEach((slide, index) => {
        slide.addEventListener("click", () => {
          self.focus(index);
        });
        const link = slide.querySelector("a.card-cta");
        link.addEventListener("focus", () => {
          self.focus(index);
        });
      });
    // self.glide && self.glide.on('run.after', function() {
    //     const index = self.glide._i;
    //     self.focus(index);
    // });
  }

  set activeSlide(index) {
    // Update carousel position
    this.glide && this.glide.go(`=${index}`);
    // Highlight active slide
    this.glide &&
      this.glide._c.Html.slides[index].classList.add("glide__slide--focus");
  }

  // event handlers
  removeFocus() {
    this.markers.forEach((marker) => {
      const gmMarker = marker[0];
      const icon = Object.assign({}, gmMarker.icon, {
        fillColor: this.settings.defaultColour,
      });
      gmMarker.setIcon(icon);
    });
    this.glide &&
      this.glide._c.Html.slides.forEach((slide) =>
        slide.classList.remove("glide__slide--focus")
      );
  }
  focus(index) {
    this.removeFocus();
    const gmMarker = this.markers[index][0];
    const isPremium = this.markers[index][1];
    const icon = Object.assign({}, gmMarker.icon, {
      fillColor: isPremium
        ? this.settings.premiumColour
        : this.settings.traditiColour,
    });
    gmMarker.setIcon(icon);
    this.map.panTo({
      lat: gmMarker.position.lat(),
      lng: gmMarker.position.lng(),
    });
    this.activeSlide = index;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/locator.js